import React from 'react'
import DetailAmenities from '../../amenitiesDetail/1'
import { RealEstateDataPageComponentData } from 'types'

interface ExternalProps {
  propertyID: string
  developmentID: string
}

type CombinedProps = RealEstateDataPageComponentData & ExternalProps

const Developement_Amenities_5 = (props: CombinedProps) => {
  return <DetailAmenities {...props} />
}

export default Developement_Amenities_5
